<template>
  <div style="width: 100%;height: 100%;margin-top:30px;font-size: 16px;">
    <div style="width:100%;height:280px;margin-top:30px;display: inline-block;" id="web3d"></div>
    <div v-if="designInfo" style="margin-left: 10px;display: inline-block;">
      款式图层列表：
      <div v-for="(layer, index) in designInfo.layers" :key="index">
        <span style="width: 100px;display: inline-block;">{{ layer.name }}</span>
        <select v-if="layer.type == 1" v-model="selectedMatIds[index]" :value="layer.gemWeb.id"
          class="margin-left: 10px;" @change="changeMat(index, layer.id, layer.type)">
          <option v-for="gem in gemWebs" :value="gem.id">{{gem.name}}</option>
        </select>
        <select v-model="selectedMatIds[index]" v-if="layer.type == 2" :value="layer.materialWeb.id"
          class="margin-left: 10px;" @change="changeMat(index, layer.id, layer.type)">
          <option v-for="mat in materialWebs" :value="mat.id" v-if="mat.typeId == layer.materialWeb.typeId">{{mat.name}}
          </option>
        </select>
      </div>
    </div>
    <div style="position: fixed;top:5px;right:10px;z-index:999">
      <button style="width:120px;height:40px;line-height:40px;font-size:20px;" @click="tryon()">
        <span v-if="!tryonState">进入试戴</span>
        <span v-if="tryonState">退出试戴</span>
      </button>
    </div>
    <div v-if="designCollocations.length>0" style="margin-top: 30px;">
      搭配列表：
      <select v-model="selectedCollocationId" @change="loadCollocation">
        <option style="font-size: 18px;" v-for="item in designCollocations" :value="item.id">搭配{{item.id}}</option>
      </select>
    </div>
  </div>
</template>
<script>
  import vplus from "@/api/index";

  export default {
    data() {
      return {
        resourceDomainName: 'https://3dres.bavlo.com/', //资源域名
        baseUrl: './static', //Web3D core目录路径
        my3d: null,
        designId: 58, //款式ID
        designInfo: null, //款式信息
        userInfo: null, //配置信息
        gemWebs: [], //宝石材质
        materialWebs: [], //其它材质
        selectedMatIds: [], //选择的材质
        tryonState: false, //试戴状态
        designCollocations: [], //搭配列表
        selectedCollocationId: 22, //选择的搭配
      }
    },
    async mounted() {

      const queryParams = this.$route.query;
      console.log('queryParams', queryParams)
      console.log('queryParams.id', queryParams.id)
      if (queryParams.id) {
        this.designId = queryParams.id
        //初始化3D场景
        let initParameter = {
          baseUrl: this.baseUrl,
          controlElementId: 'web3d',
          isEdit: false,
          resourceDomainName: this.resourceDomainName,
          isDesign: true,
          isRhino5: true,
        };
        //加载3D场景、材质相关数据
        await this.load3DSceneInfo();
        //设置场景参数
        if (this.userInfo.scene) {
          initParameter.scene = this.userInfo.scene;
        }
        this.my3d = Bavlo.initWeb3dScene(initParameter)
        //初始化3D场景尺寸比例
        this.my3d.onWindowResize(0);
        //优化锯尺
        this.my3d.allowFXAA(true)
        //自动旋转
        this.my3d.setRotationState(false);
        //加载款式
        await this.loadDesign3D();
        //加载款式搭配列表
        this.loadDesCollocations();
      }
    },
    methods: {
      //加载3D材质信息
      async load3DSceneInfo() {
        await vplus.loadUser3DInfo().then(res => {
          this.userInfo = res.user3DInfo.userInfo
          this.gemWebs = res.user3DInfo.gemWebs
          this.materialWebs = res.user3DInfo.materialWebs
        });
      },
      //加载款式
      async loadDesign3D() {
        //获取款式数据
        await vplus.loadDesignInfo(this.designId).then(res => {
          this.designInfo = res.designInfo;
          console.log('-----this.designInfo', this.designInfo)
        });
        //加载固定款3D
        this.my3d.loadDesign(this.designInfo);
      },
      //切换宝石材质
      changeMat(layerIndex, layerId, layerType) {
        let matId = this.selectedMatIds[layerIndex]
        if (layerType == 0) {
          let gem = this.gemWebs.find(item => {
            return item.id == matId
          })
          this.my3d.switchGemMaterial(layerId, gem);
        } else {
          let mat = this.materialWebs.find(item => {
            return item.id == matId
          })
          this.my3d.switchLayerMaterial(layerId, mat);
        }
      },
      //试戴
      tryon() {
        this.tryonState = !this.tryonState
        this.my3d.setTryonMode(this.tryonState)
      },
      //获取款式搭配列表
      loadDesCollocations() {
        vplus.loadDesignCollocations(this.designId).then(res => {
          this.designCollocations = res.list;
        });
      },
      //选择显示搭配
      loadCollocation() {
        let nowCollocation = this.designCollocations.find(item => {
          return item.id == this.selectedCollocationId;
        });
        for (let i = 0; i < nowCollocation.details.length; i++) {
          let collLayer = nowCollocation.details[i];
          for (let j = 0; j < this.designInfo.layers.length; j++) {
            let layer = this.designInfo.layers[j];
            if (collLayer.layerId == layer.id) {
              if (layer.type === 1) {
                this.my3d.switchGemMaterial(layer.id, collLayer.gemWeb);
              } else {
                this.my3d.switchLayerMaterial(layer.id, collLayer.materialWeb);
              }
              break;
            }
          }
        }
      }
    }
  };
</script>



// WEBPACK FOOTER //
// src/views/index.vue